import { SubmissionError } from '#helper/submission-error';
import { fetchAdditions, snackBarError } from '#action/fetch';
import { webPortalApi } from '#config/web-portal-api';
import { FETCH_PROJECT_PACKAGES } from '#action/types';
import { getRequestOptions } from '#helper';

export const fetchProjectPackages = (id, includeArchived = false) => dispatch =>
  dispatch(fetchAdditions(`project/${id}/packageType${includeArchived ? '?includeArchived=true' : ''}`, FETCH_PROJECT_PACKAGES, { id }));

export const putProjectPackages = (id, packages) => async dispatch => {
  try {
    const res = await fetch(webPortalApi.buildApiUrl(`project/${id}/packageType`), {
      method: 'PUT',
      body: JSON.stringify(packages),
      ...getRequestOptions()
    });
    const response = await res.json();

    if (!res.ok) {
      dispatch(
        snackBarError({
          message: 'Error in request',
          ...response
        })
      );
      throw new SubmissionError(response);
    }

    return { success: true };
  } catch (e) {
    return { success: false };
  }
};
